<template>
  <div :style="styleWrapper" class="wrapper">
    <div :style="timerWrapperStyle" class="background_popup_gradient wrapper_item timerWrapper"></div>

    <div :style="bodyWrapperStyle" class="background_popup_gradient wrapper_item bodyWrapper">
      <div :style="lineDecorateStyle" class="line_decorate"></div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'CommonPopupBackground',
  props: {
    width: Number,
    height: Number
  },
  computed: {
    ...mapGetters(['getAppConfiguration']),
    timerWrapperStyle(): { width: string; height: string; top: string } {
      let width: number = this.getAppConfiguration.isLandscape ? 345 : this.width;
      let height: number = this.getAppConfiguration.isLandscape ? this.height : 210;
      let top: number = this.getAppConfiguration.isLandscape ? -10 : 642;
      return {
        width: width + 'px',
        height: height + 'px',
        top: top + 'px'
      };
    },
    bodyWrapperStyle(): { width: string; height: string } {
      let width: number = this.getAppConfiguration.isLandscape ? 640 : this.width;
      let height: number = this.getAppConfiguration.isLandscape ? this.height : 662;
      return {
        width: width + 'px',
        height: height + 'px'
      };
    },
    styleWrapper(): { width: string; height: string } {
      return {
        width: this.width + 'px',
        height: this.height + 'px'
      };
    },
    lineDecorateStyle(): { top: string; width: string } {
      let top: number = this.getAppConfiguration.isLandscape ? 61 : 55;
      let width: number = this.getAppConfiguration.isLandscape ? 1 : 0;
      return {
        top: top + 'px',
        width: `calc(100% + ${width}px)`
      };
    }
  }
});
</script>

<style lang="scss" scoped>
.wrapper {
  border: 10px solid #797c7f;
  border-radius: 28px;
}

.wrapper_item {
  width: 100%;
  height: calc(100% + 20px);
  border: 10px solid #797c7f;
  top: -10px;
  position: absolute;
  border-radius: 25px;
}

.timerWrapper {
  border-right: 11px solid #797c7f;
  left: -10px;
}

.bodyWrapper {
  border-left: 11px solid #797c7f;
  right: -10px;
}

.line_decorate {
  position: absolute;
  height: 46px;
  background-color: #303031;
  left: 0px;
}
</style>